import { path } from 'ramda'
import { globalizeSelectors } from 'zeal-redux-utils'

const localState = path(['app', 'user', 'form'])

const email = path(['email'])
const courseCode = path(['courseCode'])

export default globalizeSelectors(localState, {
  email,
  courseCode
})



// WEBPACK FOOTER //
// ./client/modules/user/selectors/form.js